import { Alert, Button, Snackbar, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { User, useTranslation } from '@/core'
import { Organism } from '@/core/architecture'
import { useSettingUserInfoModal } from '@/core/membership/useSettingUserInfoModal'

import { useNeedSettingPersonalUserSnackbar } from './useNeedSettingPersonalUserSnackbar'

type NeedSettingPersonalUserSnackbarProps = {
  user: User
}

export const NeedSettingPersonalUserSnackbar: Organism<NeedSettingPersonalUserSnackbarProps> =
  ({ user }) => {
    const { t } = useTranslation()
    const { isOpen, showModal } = useSettingUserInfoModal()
    const { open, type, onClose } = useNeedSettingPersonalUserSnackbar(user)

    return (
      <Snackbar
        open={open && !isOpen}
        onClose={onClose}
        id="NeedSettingPersonalUserSnackbar"
        autoHideDuration={6000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        sx={{ bottom: { xs: 70, md: 70 } }}
      >
        <Alert
          color="info"
          variant="filled"
          severity="success"
          icon={<Icons.Info fontSize="small" sx={{ color: 'white' }} />}
          sx={{
            padding: '6px 16px',
            width: '100%',
            maxWidth: 600 - 32,
            mx: 5,
            '.MuiAlert-message': { width: '100%' },
          }}
          action={
            <Button
              color="inherit"
              size="small"
              variant="text"
              onClick={() => showModal()}
            >
              {t(type)}
            </Button>
          }
        >
          <Typography variant="subtitle1" color="white">
            {t(
              type === 'input'
                ? 'needRegistrationCustomerInfo'
                : 'registrationMembershipUncomplete'
            )}
          </Typography>
        </Alert>
      </Snackbar>
    )
  }
